(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-kids-map"]) return;
  try {
    
if (!customElements.get('kids-map-product')) {
  customElements.define('kids-map-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-kids-data]').textContent);
      this.strings = this.data.strings;
      this.form = this.querySelector('form');
      this.image = this.querySelector('.kids-map__image');
      this.originalImage = { src: this.image.src, srcset: this.image.srcset, alt: this.image.alt };
      this.nameInput = this.querySelector('[data-kids-name]');
      this.personal = this.querySelector('[data-kids-personal]');
      this.birth = this.querySelector('[data-kids-birth]');
      this.overlay = this.querySelector('[data-kids-overlay]');
      this.live = true;
      this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      this.cartRoot = this.data.root;
      this.editKey = new URL(window.location.href).searchParams.get('kids_edit');
      this.loadingEdit = Boolean(this.editKey);
      this.busy = false;
      this.querySelectorAll('[data-kids-open]').forEach(button => button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.kidsOpen);
        if (dialog && !dialog.open) dialog.showModal();
      }));
      this.querySelectorAll('[data-kids-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
      this.querySelectorAll('.kids-map__dialog').forEach(dialog => dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      }));
      this.addEventListener('change', e => {
        if (e.target.matches('[data-kids-option]')) this.updateVariant();
        else if (e.target.closest('[data-kids-personal]')) this.updatePreview();
      });
      this.personal.addEventListener('input', () => { this.nameInput.setCustomValidity(''); this.updatePreview(); });
      this.querySelector('[data-kids-live]').addEventListener('click', () => this.showLive());
      this.querySelectorAll('[data-kids-photo]').forEach(button => button.addEventListener('click', () => {
        this.live = false;
        this.querySelector('[data-kids-art]').classList.add('kids-map__art--photo');
        this.querySelector('[data-kids-art]').classList.remove('kids-map__art--stretched');
        this.image.removeAttribute('srcset');
        this.image.src = button.dataset.kidsPhoto;
        this.image.alt = button.dataset.kidsPhotoAlt;
        this.image.style.aspectRatio = '3 / 2';
        this.overlay.setAttribute('hidden', '');
        this.setActiveThumb(button);
      }));
      this.form.addEventListener('submit', e => {
        e.preventDefault();
        this.updateVariant(false);
        if (!this.variant?.available || this.isPaper || (this.isPersonal && !this.nameInput.value.trim())) {
          e.preventDefault();
          if (this.isPersonal && !this.nameInput.value.trim()) {
            this.nameInput.setCustomValidity(this.strings.nameError);
            this.nameInput.reportValidity();
          }
          return;
        }
        if (this.editKey) {
          if (!this.busy && !this.loadingEdit && !this.editFailed) this.saveCartItem();
        } else if (!this.busy) this.addCartItem();
      });
      this.updateVariant(false);
      if (this.editKey) this.loadCartItem();
    }
    async cartRequest(path, body) {
      const response = await fetch(this.cartRoot + path, {
        method: body ? 'POST' : 'GET',
        headers: body ? {'Content-Type': 'application/json', 'Accept': 'application/json'} : {'Accept': 'application/json'},
        body: body ? JSON.stringify(body) : undefined,
        credentials: 'same-origin',
        cache: 'no-store'
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || this.strings.saveError);
      return result;
    }
    editStatus(message, error = false) {
      const status = this.querySelector('[data-kids-edit-status]');
      status.hidden = false;
      status.textContent = message;
      status.classList.toggle('kids-map__status--error', error);
    }
    async loadCartItem() {
      this.querySelector('[data-kids-edit-notice]').hidden = false;
      this.editStatus(this.strings.loadingEdit);
      try {
        const cart = await this.cartRequest('cart.js');
        const item = cart.items.find(line => line.key === this.editKey && String(line.product_id) === String(this.data.productId));
        const variant = item && this.data.variants.find(v => v.id === item.variant_id);
        if (!item || !variant) throw new Error(this.strings.itemMissing);
        this.originalItem = item;
        this.querySelectorAll('[data-kids-option]').forEach(input => {
          const value = variant.options[Number(input.dataset.kidsOption)];
          if (input.type === 'radio') input.checked = input.value === value;
          else input.value = value;
        });
        const properties = item.properties || {};
        for (const [selector, key] of [['name','Name'],['date','Geburtsdatum'],['place','Geburtsort'],['height','Größe bei Geburt'],['weight','Gewicht bei Geburt']]) {
          this.querySelector(`[data-kids-${selector}]`).value = properties[key] || '';
        }
        this.querySelector('[data-kids-profile]').value = properties.Steckbrief === 'Mit Steckbrief' ? 'Mit Steckbrief' : 'Ohne Steckbrief';
        this.loadingEdit = false;
        this.updateVariant();
        this.editStatus(this.strings.editReady.replace('{quantity}', String(item.quantity)));
      } catch (error) {
        this.editFailed = true;
        this.loadingEdit = false;
        this.editStatus(error.message || this.strings.itemMissing, true);
        this.updateVariant(false);
      }
    }
    cartProperties() {
      const properties = {...this.originalItem.properties};
      const keys = ['Name','Kartentitel','Steckbrief','Geburtsdatum','Geburtsort','Größe bei Geburt','Gewicht bei Geburt'];
      keys.forEach(key => { properties[key] = ''; });
      if (this.isPersonal) {
        const form = new FormData(this.form);
        keys.forEach(key => { properties[key] = String(form.get(`properties[${key}]`) || ''); });
      }
      return properties;
    }
    sameProperties(left = {}, right = {}) {
      const clean = value => Object.entries(value || {}).filter(([,v]) => v !== '' && v != null).sort(([a],[b]) => a.localeCompare(b));
      return JSON.stringify(clean(left)) === JSON.stringify(clean(right));
    }
    async addCartItem() {
      this.busy = true;
      this.updateVariant(false);
      this.editStatus(this.strings.saving);
      const properties = {};
      for (const [key, value] of new FormData(this.form)) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = String(value);
      }
      try {
        await this.cartRequest('cart/add.js', {items:[{id:this.variant.id, quantity:1, properties}]});
        window.location.assign(this.data.cartUrl);
      } catch (error) {
        this.busy = false;
        this.editStatus(error.message || this.strings.saveError, true);
        this.updateVariant(false);
      }
    }
    async saveCartItem() {
      this.busy = true;
      this.updateVariant(false);
      this.editStatus(this.strings.saving);
      try {
        const cart = await this.cartRequest('cart.js');
        const item = cart.items.find(line => line.key === this.editKey);
        if (!item || item.quantity !== this.originalItem.quantity || !this.sameProperties(item.properties, this.originalItem.properties)) throw new Error(this.strings.itemChanged);
        const properties = this.cartProperties();
        if (this.variant.id === item.variant_id) {
          await this.cartRequest('cart/change.js', {id:item.key, quantity:item.quantity, properties});
        } else {
          const existing = cart.items.find(line => line.variant_id === this.variant.id && this.sameProperties(line.properties, properties));
          const priorQuantity = existing?.quantity || 0;
          const added = await this.cartRequest('cart/add.js', {items:[{id:this.variant.id, quantity:item.quantity, properties}]});
          const addedKey = added.items[0].key;
          try {
            await this.cartRequest('cart/change.js', {id:item.key, quantity:0});
          } catch (error) {
            const current = await this.cartRequest('cart.js');
            if (current.items.some(line => line.key === item.key)) {
              const replacement = current.items.find(line => line.key === addedKey);
              if (replacement) await this.cartRequest('cart/change.js', {id:addedKey, quantity:priorQuantity});
              throw error;
            }
          }
        }
        window.location.assign(this.data.cartUrl);
      } catch (error) {
        this.editStatus(error.message || this.strings.saveError, true);
        this.busy = false;
        this.updateVariant(false);
      }
    }
    setActiveThumb(button) {
      this.querySelectorAll('.kids-map__thumb').forEach(b => {
        b.classList.toggle('kids-map__thumb--active', b === button);
        b.setAttribute('aria-pressed', String(b === button));
      });
    }
    showLive() {
      this.live = true;
      this.querySelector('[data-kids-art]').classList.remove('kids-map__art--photo');
      this.querySelector('[data-kids-art]').classList.toggle('kids-map__art--stretched', /KR\d/.test(this.variant.sku));
      this.image.src = this.originalImage.src;
      this.image.srcset = this.originalImage.srcset;
      this.image.alt = this.originalImage.alt;
      this.image.style.aspectRatio = '3 / 2';
      this.setActiveThumb(this.querySelector('[data-kids-live]'));
      this.overlay.toggleAttribute('hidden', !this.isPersonal);
    }
    titleFor(name) {
      return `${name} ${this.dataset.language === 'en' ? 'little world' : 'kleine Welt'}`;
    }
    updateOptionAvailability(selected) {
      this.querySelectorAll('[data-kids-option]').forEach(input => {
        const index = Number(input.dataset.kidsOption);
        const available = value => this.data.variants.some(variant =>
          variant.available && !/(?:EN)?PP\d/.test(variant.sku) &&
          variant.options[index] === value &&
          selected.slice(0, index).every((prior, position) => variant.options[position] === prior)
        );
        const label = (value, enabled) => enabled ? value : `${value} – ${this.strings.soldOut}`;
        if (input.type === 'radio') {
          input.disabled = !available(input.value);
          input.nextElementSibling.textContent = label(input.value, !input.disabled);
        } else {
          Array.from(input.options).forEach(option => {
            option.disabled = !available(option.value);
            option.textContent = label(option.value, !option.disabled);
          });
        }
      });
    }
    updateVariant(changeUrl = true) {
      const selected = [];
      this.querySelectorAll('[data-kids-option]').forEach(input => {
        if (input.type !== 'radio' || input.checked) selected[Number(input.dataset.kidsOption)] = input.value;
      });
      this.updateOptionAvailability(selected);
      this.variant = this.data.variants.find(v => v.options.every((value, i) => value === selected[i]));
      if (!this.variant) return;
      this.isPersonal = this.variant.sku.endsWith('CP');
      this.isPaper = /(?:EN)?PP\d/.test(this.variant.sku);
      this.querySelector('[data-kids-variant]').value = this.variant.id;
      this.personal.hidden = !this.isPersonal;
      this.personal.disabled = !this.isPersonal;
      this.nameInput.required = this.isPersonal;
      if (!this.isPersonal) this.nameInput.setCustomValidity('');
      this.querySelector('[data-kids-price]').textContent = this.money.format(this.variant.price / 100);
      const available = this.variant.available && !this.isPaper;
      const button = this.querySelector('[data-kids-submit]');
      button.disabled = !available || this.busy || this.loadingEdit || this.editFailed;
      button.textContent = this.busy ? this.strings.saving : available ? (this.editKey ? this.strings.save : this.strings.add) : this.strings.soldOut;
      this.querySelector('[data-kids-availability]').textContent = this.isPaper ? this.strings.paper : !available ? this.strings.soldOut : /KR12080/.test(this.variant.sku) ? this.strings.largeReady : this.strings.ready;
      this.querySelector('[data-kids-art]').classList.toggle('kids-map__art--stretched', this.live && /KR\d/.test(this.variant.sku));
      if (changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState({}, '', url);
      }
      this.updatePreview();
    }
    updatePreview() {
      const hasProfile = this.isPersonal && this.querySelector('[data-kids-profile]').value === 'Mit Steckbrief';
      this.birth.hidden = !hasProfile;
      this.birth.disabled = !hasProfile;
      this.querySelector('[data-kids-profile-art]').toggleAttribute('hidden', !hasProfile);
      const rawName = this.nameInput.value;
      const text = this.querySelector('[data-kids-name-preview]');
      text.textContent = rawName;
      text.setAttribute('font-size', '260');
      text.removeAttribute('textLength');
      text.removeAttribute('lengthAdjust');
      this.querySelector('[data-kids-title-property]').value = rawName ? this.titleFor(rawName) : '';
      const val = key => this.querySelector(`[data-kids-${key}]`).value;
      const date = val('date');
      const printLocale = this.dataset.language === 'en' ? 'en-GB' : 'de-DE';
      const values = {date: date ? new Intl.DateTimeFormat(printLocale, {day:'2-digit', month:this.dataset.language === 'en' ? 'short' : '2-digit', year:'numeric'}).format(new Date(date + 'T12:00:00')) : '', place:val('place'), height:val('height'), weight:val('weight')};
      this.querySelectorAll('[data-kids-profile-value]').forEach(text => {
        text.textContent = values[text.dataset.kidsProfileValue] || '';
        text.removeAttribute('textLength');
        text.removeAttribute('lengthAdjust');
      });
      if (this.isPersonal) this.showLive();
      else this.overlay.setAttribute('hidden', '');
      requestAnimationFrame(() => {
        const nameWidth = text.getComputedTextLength();
        const maxNameWidth = this.dataset.language === 'en' ? 1110 : 1150;
        if (nameWidth > maxNameWidth) text.setAttribute('font-size', String(260 * maxNameWidth / nameWidth));
        this.querySelectorAll('[data-kids-profile-value]').forEach(span => {
          if (span.getComputedTextLength() > 190) {
            span.setAttribute('textLength','190');
            span.setAttribute('lengthAdjust','spacingAndGlyphs');
          }
        });
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
